module.exports = __webpack_public_path__ + "static/media/home_header_bg.7f542aed.svg";